import React, { useRef } from "react"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import "./style.css"

/**
 * new feature:  untuk date range gunakan props minDate untuk validation end date dimana minDate didapat dari startDate
 */

export default function DateInput({ ...rest }) {
  const refComp = useRef(null)

  const clearDate = () => {
    refComp.current.flatpickr.clear()
    rest.clear()
  }

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Flatpickr
        options={{
          mode: "single",
          dateFormat: "Y-m-d",
          minDate: rest.minDate,
          disable: !rest.disabledDates ? [] : rest.disabledDates,
          disableMobile: "true",
        }}
        placeholder="年/月/日"
        ref={refComp}
        {...rest}
      />
      <button className="clear-btn" onClick={clearDate}>
        <i className="bx bx-x-circle" style={{ fontSize: 16 }} />
      </button>
    </div>
  )
}
